// components
import { IconButton, MuiTooltip, WarningRoundedIcon } from "@common";
import { INTEGRATION_CODE_SAP_SUCCESS_FACTOR } from "@constants";
const WarningCode = ({ integrationCode, ...props }) => {
    // Add integration Code and the ToolTip You want to Display
    const getTooltipTitle = () => {
        if (integrationCode === INTEGRATION_CODE_SAP_SUCCESS_FACTOR) {
            return "Please use the certificate provided by Piedap to configure the SuccessFactors OAuth integration.";
        }
        else {
            return "Please use the certificate provided by Piedap to configure the OAuth integration.";
        }
    };
    return (
        <MuiTooltip title={getTooltipTitle()}>
            <IconButton>
                <WarningRoundedIcon sx={{ color: "orange !important", fontSize: "1.8rem", }} />
            </IconButton>
        </MuiTooltip>
    );
};
export default WarningCode;
